<template>
  <div class="detail_apply_bottom" v-if="imageTextCenter != null">
    <div class="left_box">
      <div class="nav">
        <div class="text">
          <div class="textInfo">
            <!-- 标题部分 -->
            <div class="text_title">
              {{ imageTextCenter.title }}
            </div>
            <!-- 浏览量部分 -->
            <div class="textNum">
              <div>发布时间：{{ imageTextCenter.release_time }}</div>
              <div>
                来自：{{ imageTextCenter.camp_name }} 第{{
                  imageTextCenter.days
                }}天
              </div>
            </div>
          </div>
          <div v-html="imageTextCenter.content"></div>
          <div class="miaoshu"></div>
        </div>
        <!-- 按钮部分 -->
        <div>
          <div class="winBtn" @click="GoCard()">
            {{
              imageTextCenter.is_clock_in == 0
                ? "我已完成，去写日记"
                : "我已打卡，查看日记"
            }}
            <i class="iconfont icon-tianxie"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="right_box">
      <!-- 按钮部分 -->
      <div class="winBtn" @click="GoCard()">
        {{
          imageTextCenter.is_clock_in == 0
            ? "我已完成，去写日记"
            : "我已打卡，查看日记"
        }}
        <i class="iconfont icon-tianxie"></i>
      </div>

      <!-- 数据仪表盘部分 -->
      <div class="studyData">
        <div class="studyData_top">
          <!-- 排行榜和日历部分 -->
          <div class="studyData_top_item" @click="topNumberFlageChange()">
            <!-- topNumberFlage为是否显示排行榜 -->
            <div
              class="img_box"
              :style="topNumberFlage ? 'background: #2DCBD5' : ''"
            >
              <i
                class="iconfont"
                :class="topNumberFlage ? 'icon-renwujindu' : 'icon-paihangbang'"
              ></i>
            </div>
            <div class="text">{{ topNumberFlage ? "打卡进度" : "排行榜" }}</div>
          </div>
          <!-- 我的日记 -->
          <div
            class="studyData_top_item"
            @click="GoHome(myitem.detail.user_id)"
          >
            <div class="img_box" style="background: #ff8673">
              <i class="iconfont icon-riji"></i>
            </div>
            <div class="text">我的日记</div>
          </div>
          <!-- 今日分享部分 -->
          <div class="studyData_top_item" @click="todayFn()">
            <div class="img_box" style="background: #26d3bc">
              <i class="iconfont icon-fenxiang"></i>
            </div>
            <div class="text">今日分享</div>
          </div>
        </div>
        <dashBoadr
          :myDashBoadr="myDashBoadr"
          v-if="shuaxing"
          v-show="!topNumberFlage"
        ></dashBoadr>
        <!-- 新增的排行榜部分 -->
        <div class="topSearch_box" v-show="topNumberFlage">
          <topSearch></topSearch>
        </div>
      </div>
      <div>
        <linkTeacher :mykefu="myitem.kefu" v-if="myitem != null"></linkTeacher>
      </div>
      <!-- 微信二维码加群部分 -->
      <div class="qrCode" v-if="QrCodeFlag">
        <div>打卡微信群</div>
        <div class="qr">
          <img :src="myitem.kefu_group.kefu_group" alt="" />
        </div>
      </div>
    </div>
    <!-- 今日分享图片 Start -->
    <el-dialog
      :visible.sync="todayShare"
      width="23.4375rem"
      class="cardImg"
      v-if="todayShare"
    >
      <!-- 用来撑开盒子 -->
      <img :src="todyTask.share_img" alt="" class="cardOk_img" />
      <!-- <img src="@/assets/test.png" alt="" class="cardOk_img" /> -->
    </el-dialog>
  </div>
</template>

<script>
// 引入仪表盘组件
import dashBoadr from "@/components/detail_child/dashBoadr.vue";
// 引入排行榜组件
import topSearch from "@/components/topSearch.vue";
// 引入添加老师二维码组件
import linkTeacher from "@/components/text_child/link_teacher.vue";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      // 右侧仪表盘是显示排行榜还是显示日历
      topNumberFlage: false,
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      camp_id: this.$route.params.id,
      // 仪表盘部分数据刷新控制伐
      shuaxing: false,
      // 训练营数据
      myitem: null,
      // 仪表盘数据
      myDashBoadr: null,
      // 二维码变量
      QrCodeFlag: null,
      // 页面加载动画
      loading: this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 1)",
      }),
      // 图文详情
      imageTextCenter: null,
      // 今日分享部分
      todayShare: false,
    };
  },
  components: {
    dashBoadr,
    topSearch,
    linkTeacher,
  },
  mounted() {
    // 拉取仪表盘数据
    this.getCampUserLog();
    // 拉取训练营数据
    this.getCampDetail();
    // 拉取图文详情部分
    this.getGraphicLibrary();
  },
  methods: {
    ...mapMutations(["mydetailMianbao"]),
    // 根据当前训练营ID请求当前用户仪表盘信息
    getCampUserLog() {
      this.$axios
        .get("/getCampUserLog", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.camp_id,
          },
        })
        .then((doc) => {
          this.shuaxing = false;
          this.myDashBoadr = doc;
          // 向上返回学习进度
          setTimeout(() => {
            this.shuaxing = true;
          }, 200);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求训练营详情列表
    getCampDetail() {
      this.$axios
        .get("/getCampDetail", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.camp_id,
          },
        })
        .then((doc) => {
          // if (!doc.is_apply) {
          //   alert("同学，登录并且报名才能学习噢~~~~~");
          //   let myhash = window.location.href;
          //   myhash = myhash.replace(/study/g, "apply");
          //   console.log(myhash);
          //   window.location.href = myhash;
          // }
          this.myitem = doc;
          this.mydetailMianbao({ detail: doc.detail, study: true });
          // 根据返回的值动态设置进度条的进度
          // this.$(".bar_box_bar").css("width", doc.detail.camp_learn_rate + "%");
          if (
            sessionStorage.getItem("console") == null &&
            this.$route.query.type == null
          ) {
            this.$alert(this.listInfo.lesson_log[0].content, "提示", {
              confirmButtonText: "确定",
            });
            sessionStorage.setItem("console", false);
          }

          // 判断当前是否有加群二维码
          if (doc.kefu_group != null) {
            this.QrCodeFlag = true;
            // console.log(val.kefu_group);
            console.log(this.QrCodeFlag);
          } else {
            this.QrCodeFlag = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求图文详情
    getGraphicLibrary() {
      this.$axios
        .get("/getGraphicLibrary", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            id: this.$route.query.pattern_id,
            camp_id: this.camp_id,
            lesson_id: this.$route.query.lesson_id,
          },
        })
        .then((doc) => {
          console.log(doc);
          this.imageTextCenter = doc;
          // 请求返回之后关闭页面加载动画
          this.loading.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转打卡页并唤起打卡/如果已打卡则跳转我的日记页面
    GoCard() {
      if (this.imageTextCenter.is_clock_in == 0) {
        // 未打卡跳转打卡
        this.$router.push({
          path: `/Detail/study/${this.camp_id}`,
          query: {
            camp: this.camp_id,
            type: "back",
            imageText: this.imageTextCenter.days,
          },
        });
      } else {
        // 已打卡跳我的日记
        this.$router.push({
          path: `/home/${this.myitem.detail.user_id}`,
          query: {
            camp: this.camp_id,
            type: "back",
            user_id_to: this.myitem.detail.user_id,
          },
        });
      }
    },
    // 切换右侧仪表盘是显示日历还是显示排行榜
    topNumberFlageChange() {
      this.topNumberFlage = !this.topNumberFlage;
    },
    // 跳转我的日记
    GoHome(item) {
      this.$router.push({
        path: `/home/${item}`,
        query: {
          camp: this.mycamp_id,
          user_id_to: item,
        },
      });
    },
    //今日分享部分图片
    todayFn() {
      // 如果今日分享图片为空则提示今日还未打卡
      if (!this.todyTask) {
        this.$message({
          message: "您今日还未打卡噢~",
          type: "warning",
        });
        return;
      }
      if (this.todyTask.share_img == null) {
        this.$message({
          message: "您今日还未打卡或者当前打卡图还未生成",
          type: "warning",
        });
        return;
      }

      this.todayShare = true;
    },
  },
  computed: {
    todyTask() {
      // 首先计算出当前日期
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // 当前日期
      let currentdate = `${year}-${month}-${strDate}`;
      console.log(currentdate);

      let todayTask = null;

      // 区分天数打卡和作业打卡进行数据清洗
      if (this.myitem.lessons) {
        // 如果是天数打卡则根据当前时间对数据进行清洗
        if (this.myitem.detail.sign_type == "天数打卡") {
          this.myitem.lessons.forEach((element) => {
            if (element.endOfDate == currentdate) {
              todayTask = element;
            }
          });
        } else if (this.myitem.detail.sign_type == "作业打卡") {
          //如果是作业打卡则根据上次学到位置进行数据清洗，这种模式会有三种状态
          // 一、新开训练营没有上次学到位置，这种情况直接取第一天的课程
          if (this.myitem.last_learn == null) {
            todayTask = this.myitem.lessons[0];
          } else if (this.myitem.last_learn != null) {
            // 二、有上次学到的位置则根据取上一节课加一
            let thisDay = this.myitem.last_learn.day + 1;
            this.myitem.lessons.forEach((element) => {
              if (element.day == thisDay) {
                todayTask = element;
              }
            });

            // 三、如果上节课加一之后没有匹配的对象则为最后一节课，这种情况还是取第一节课
            if (todayTask == null) {
              todayTask = this.myitem.lessons[0];
            }
          }
        }
      }
      console.log(todayTask);
      return todayTask;
    },
  },
};
</script> 

<style lang="less" scoped>
.detail_apply_bottom {
  margin-top: 1.875rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: auto;
  // 下方左侧选项卡部分盒子
  .left_box {
    padding: 3.3125rem 3.25rem;
    width: 51.25rem;
    // height: 63.75rem;
    background: #ffffff;
    box-shadow: 0px 0.125rem 0.375rem 0px rgba(212, 214, 216, 0.3);
    // 富文本部分
    .nav {
      .text {
        margin-bottom: 2.5rem;
        width: 100%;
        height: auto;
        // 标题部分
        .textInfo {
          .text_title {
            text-align: center;
            font-size: 1.5rem;
            color: #404040;
            font-weight: bold;
          }
          // 信息部分
          .textNum {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 1.25rem 0;
            color: #999999;
            font-size: 14px;
          }
        }
        /deep/ img {
          padding: 1rem 0;
          max-width: 100%;
          display: block;
          margin: 0 auto;
        }
        /deep/table {
          max-width: 100% !important;
        }
        /deep/p {
          line-height: 2rem;
        }
        /deep/ iframe {
          margin: 1rem 0;
          width: 100% !important;
        }
        .miaoshu {
          margin-top: 1rem;
          color: #999;
          font-size: 0.8rem;
        }
      }
    }
    .winBtn {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 3.125rem;
      background: linear-gradient(99deg, #ee764a, #f37327, #f55a2f);
      box-shadow: 0px 0.3125rem 1.125rem 0px rgba(255, 60, 0, 0.46);
      border-radius: 0.3125rem;
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      .icon-tianxie::before {
        font-size: 1.25rem;
        margin-left: 0.625rem;
        font-weight: 400;
      }
    }
    // 选项卡部分
  }
  // 下方右侧讲师介绍部分盒子
  .right_box {
    width: 24rem;
    height: auto;
    // background: #ffffff;
    .studyData {
      box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      margin-bottom: 1.25rem;
      width: 100%;
      height: auto;
      background-color: #fff;
      .studyData_top {
        padding: 0 2rem;
        height: 7.5rem;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .studyData_top_item {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img_box {
            margin-bottom: 0.625rem;
            width: 2.4375rem;
            height: 2.4375rem;
            background: #ffc052;
            border-radius: 50%;

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .iconfont::before {
              font-size: 1.25rem;
              color: #fff;
            }
          }
          .text {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #757c82;
            line-height: 1.625rem;
          }
        }
        .studyData_top_item:hover {
          .text {
            color: #ffba61;
          }
        }
      }
      /deep/.topSrarch {
        width: 100%;
        .topSrarch_bottom {
          padding: 0 1.25rem;
        }
      }
    }
    .winBtn {
      margin-bottom: 1.5rem;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 3.125rem;
      background: linear-gradient(99deg, #ee764a, #f37327, #f55a2f);
      box-shadow: 0px 0.3125rem 1.125rem 0px rgba(255, 60, 0, 0.46);
      border-radius: 0.3125rem;
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      .icon-tianxie::before {
        font-size: 1.25rem;
        margin-left: 0.625rem;
        font-weight: 400;
      }
    }
  }
  // 今日分享图部分
  /deep/.cardImg {
    .el-dialog {
      margin-top: 8vh !important;
    }
    .el-dialog__body {
      min-height: 41.6875rem;
    }
    img {
      max-width: 100%;
    }
  }

  // 微信二维码加群部分
  .qrCode {
    margin-top: 1.4375rem;
    padding: 1.25rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 16.875rem;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(212, 214, 216, 0.3);

    font-size: 1.25rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4c4c4c;
    .qr {
      margin-top: 2.0875rem;
      width: 10.375rem;
      height: 10.375rem;
      // background-color:red;
      img {
        width: 100%;
      }
    }
  }
}
</style>